import type { RouteRecordRaw } from 'vue-router';
import { AdminUsersPage } from '@/pages/admin';

export const routeName = 'AdminUsuarios';

export const route: RouteRecordRaw = {
  path: 'usuarios',
  name: routeName,
  component: AdminUsersPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Usuários',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};
